<template>
  <input
    :type="type"
    :placeholder="placeholder"
    :value.prop="value"
    @input="update"
    @focus="$emit('input-focus', $event.target.value)"
    @blur="$emit('input-blur', $event.target.value)"
  />
</template>

<script>
export default {
  name: 'BaseInput',
  props: {
    type: {
      type: String,
      default: 'text'
    },
    placeholder: {
      type: String
    },
    value: {
      type: String
    },
    vuelidate: {
      type: Object
    },
    options: {
      type: String
    }
  },
  methods: {
    update($event) {
      console.log($event.target.value)
      this.vuelidate.$touch()
      this.$emit('input', $event.target.value)
    }
  }
}
</script>
